import {SharedQuestion} from "./SharedQuestion";

export class DragAndDropSharedQuestion extends SharedQuestion {

    protected _validationMessage = 'drag_and_drop_validation_message';
    protected values:IValue[];

    public question:IQuestion;

    isValid():boolean {
        super.isValid();

        const containers = this.question.meta.containers;
        for (let containerIndex = 0; containerIndex < containers.length; containerIndex++) {
            const container = containers[containerIndex];

            if (container.min) {
                if (this.values[containerIndex].value.length < container.min) {
                    this._validationMessage = 'min_drag_and_drop_validation_message';
                    return false;
                }
            }

            if (container.max) {
                if (this.values[containerIndex].value.length > container.max) {
                    this._validationMessage = 'max_drag_and_drop_validation_message';
                    return false;
                }
            }
        }

        return true;
    }

    validationMessage() : string {
        var message = this.getMessage('required');
        if (message) {
            return message;
        }

        return this._validationMessage;
    }

    getValue():IValue[] {
        return this.values;
    }

    setValue(values:IValue[]) {
        this.values = values;
    }

    pushValue(value:IValue, index:number) {
        this.values[index] = value;
    }

    satisfiesValue(currentValues:IValue[], value:IValue): boolean {
        return angular.equals(value, currentValues[0].value); // @TODO: requires fix, which container is which
    }
}